// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-CompanyDetails-AdditionalDomains-styles___paper--abZAe {
  padding: 32px;
  max-width: 736px;
  margin: 0 0 30px;
}

.components-CompanyDetails-AdditionalDomains-styles___sectionTitle--JX_sJ h2 {
    font-size: 17px;
    font-weight: 500;
    padding-bottom: 8px;
    color: #1b2432;
  }

.components-CompanyDetails-AdditionalDomains-styles___sectionTitle--JX_sJ .components-CompanyDetails-AdditionalDomains-styles___description--OCpsO {
    font-size: 13px;
    color: #6d717a;
  }

.components-CompanyDetails-AdditionalDomains-styles___tableCell--Z0rGM {
  font-size: 15px !important;
  padding: 14px 0 !important;
}

.components-CompanyDetails-AdditionalDomains-styles___tableCell--Z0rGM.components-CompanyDetails-AdditionalDomains-styles___removeCell--JyxZD {
    text-align: right;
  }

.components-CompanyDetails-AdditionalDomains-styles___addDomain--wQAtg {
  display: flex;
  align-items: center;
  color: #1e8aff !important;
  font-size: 13px;
  cursor: pointer;
  margin-top: 26px;
}

.components-CompanyDetails-AdditionalDomains-styles___addDomain--wQAtg:hover {
    color: #f6f6f7;
  }

.components-CompanyDetails-AdditionalDomains-styles___addDomain--wQAtg {
  font-weight: 500;
}

.components-CompanyDetails-AdditionalDomains-styles___addIcon--yEr87 {
  height: 18px;
  margin-right: 5px;
}

.components-CompanyDetails-AdditionalDomains-styles___buttonRemove--CFHzC {
  border: 1px solid #fc3b60 !important;
  border-radius: 4px !important;
  background-color: transparent !important;
  box-shadow: none !important;
  padding: 4px 8px;
  font-size: 13px;
  color: #fc3b60 !important;
  letter-spacing: 0;
  text-align: center;
}

.components-CompanyDetails-AdditionalDomains-styles___dialogBox--fBE4r {
  min-width: 540px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.components-CompanyDetails-AdditionalDomains-styles___dialogBox--fBE4r .components-CompanyDetails-AdditionalDomains-styles___title--CZJmw {
    font-size: 29px;
    color: #1b2432;
    background-color: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: 1 0 auto;
    padding: 32px 32px 0;
  }

.components-CompanyDetails-AdditionalDomains-styles___dialogBox--fBE4r .components-CompanyDetails-AdditionalDomains-styles___title--CZJmw .components-CompanyDetails-AdditionalDomains-styles___closeIcon--de9lO {
      top: 22px;
      right: 21px;
      position: absolute;
      width: -moz-fit-content !important;
      width: fit-content !important;
    }

.components-CompanyDetails-AdditionalDomains-styles___dialogBox--fBE4r .components-CompanyDetails-AdditionalDomains-styles___title--CZJmw .components-CompanyDetails-AdditionalDomains-styles___closeIcon--de9lO .components-CompanyDetails-AdditionalDomains-styles___svg--xTqlj {
        font-size: 26px;
      }

.components-CompanyDetails-AdditionalDomains-styles___dialogBox--fBE4r .components-CompanyDetails-AdditionalDomains-styles___domainInput--mN5fE {
    min-width: 700px;
    text-align: right;
    padding: 0 32px 32px;
  }

.components-CompanyDetails-AdditionalDomains-styles___dialogBox--fBE4r .components-CompanyDetails-AdditionalDomains-styles___domainInput--mN5fE .components-CompanyDetails-AdditionalDomains-styles___inputWrapper--BUFfV {
      margin-top: 8px;
      margin-bottom: 32px;
      padding: 8px 0 0;
    }

.components-CompanyDetails-AdditionalDomains-styles___dialogBox--fBE4r .components-CompanyDetails-AdditionalDomains-styles___actionsRight--j03nz {
    justify-content: flex-end;
    margin: 20px 0 0;
    display: flex;
  }

.components-CompanyDetails-AdditionalDomains-styles___dialogBox--fBE4r .components-CompanyDetails-AdditionalDomains-styles___actionsRight--j03nz .components-CompanyDetails-AdditionalDomains-styles___button--RKhXp {
      flex: 0 1 200px;
    }
`, "",{"version":3,"sources":["webpack://./components/CompanyDetails/AdditionalDomains/styles.pcss","<no source>"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAGE;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;EAChB;;AAEA;IACE,eAAe;IACf,cAAc;EAChB;;AAGF;EACE,0BAA0B;EAC1B,0BAA0B;AAK5B;;AAHE;IACE,iBAAiB;EACnB;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,gBAAgB;AAKlB;;AAJE;IACE,cAAc;EAChB;;ACtCF;EDuCE;CCvCF;;AD0CA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,wCAAwC;EACxC,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AA6CzB;;AA3CE;IACE,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,oBAAoB;EAYtB;;AAVE;MACE,SAAS;MACT,WAAW;MACX,kBAAkB;MAClB,kCAA6B;MAA7B,6BAA6B;IAK/B;;AAHE;QACE,eAAe;MACjB;;AAIJ;IACE,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;EAOtB;;AALE;MACE,eAAe;MACf,mBAAmB;MACnB,gBAAgB;IAClB;;AAGF;IACE,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;EAKf;;AAHE;MACE,eAAe;IACjB","sourcesContent":[".paper {\n  padding: 32px;\n  max-width: 736px;\n  margin: 0 0 30px;\n}\n\n.sectionTitle {\n  h2 {\n    font-size: 17px;\n    font-weight: 500;\n    padding-bottom: 8px;\n    color: #1b2432;\n  }\n\n  .description {\n    font-size: 13px;\n    color: #6d717a;\n  }\n}\n\n.tableCell {\n  font-size: 15px !important;\n  padding: 14px 0 !important;\n\n  &.removeCell {\n    text-align: right;\n  }\n}\n\n.addDomain {\n  display: flex;\n  align-items: center;\n  color: #1e8aff !important;\n  font-size: 13px;\n  cursor: pointer;\n  margin-top: 26px;\n  &:hover {\n    color: #f6f6f7;\n  }\n  font-weight: 500;\n}\n\n.addIcon {\n  height: 18px;\n  margin-right: 5px;\n}\n\n.buttonRemove {\n  border: 1px solid #fc3b60 !important;\n  border-radius: 4px !important;\n  background-color: transparent !important;\n  box-shadow: none !important;\n  padding: 4px 8px;\n  font-size: 13px;\n  color: #fc3b60 !important;\n  letter-spacing: 0;\n  text-align: center;\n}\n\n.dialogBox {\n  min-width: 540px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n\n  .title {\n    font-size: 29px;\n    color: #1b2432;\n    background-color: #fff;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex: 1 0 auto;\n    padding: 32px 32px 0;\n\n    .closeIcon {\n      top: 22px;\n      right: 21px;\n      position: absolute;\n      width: fit-content !important;\n\n      .svg {\n        font-size: 26px;\n      }\n    }\n  }\n\n  .domainInput {\n    min-width: 700px;\n    text-align: right;\n    padding: 0 32px 32px;\n\n    .inputWrapper {\n      margin-top: 8px;\n      margin-bottom: 32px;\n      padding: 8px 0 0;\n    }\n  }\n\n  .actionsRight {\n    justify-content: flex-end;\n    margin: 20px 0 0;\n    display: flex;\n\n    .button {\n      flex: 0 1 200px;\n    }\n  }\n}\n",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `components-CompanyDetails-AdditionalDomains-styles___paper--abZAe`,
	"sectionTitle": `components-CompanyDetails-AdditionalDomains-styles___sectionTitle--JX_sJ`,
	"description": `components-CompanyDetails-AdditionalDomains-styles___description--OCpsO`,
	"tableCell": `components-CompanyDetails-AdditionalDomains-styles___tableCell--Z0rGM`,
	"removeCell": `components-CompanyDetails-AdditionalDomains-styles___removeCell--JyxZD`,
	"addDomain": `components-CompanyDetails-AdditionalDomains-styles___addDomain--wQAtg`,
	"addIcon": `components-CompanyDetails-AdditionalDomains-styles___addIcon--yEr87`,
	"buttonRemove": `components-CompanyDetails-AdditionalDomains-styles___buttonRemove--CFHzC`,
	"dialogBox": `components-CompanyDetails-AdditionalDomains-styles___dialogBox--fBE4r`,
	"title": `components-CompanyDetails-AdditionalDomains-styles___title--CZJmw`,
	"closeIcon": `components-CompanyDetails-AdditionalDomains-styles___closeIcon--de9lO`,
	"svg": `components-CompanyDetails-AdditionalDomains-styles___svg--xTqlj`,
	"domainInput": `components-CompanyDetails-AdditionalDomains-styles___domainInput--mN5fE`,
	"inputWrapper": `components-CompanyDetails-AdditionalDomains-styles___inputWrapper--BUFfV`,
	"actionsRight": `components-CompanyDetails-AdditionalDomains-styles___actionsRight--j03nz`,
	"button": `components-CompanyDetails-AdditionalDomains-styles___button--RKhXp`
};
module.exports = ___CSS_LOADER_EXPORT___;
